import moment from "moment";

// Language configuration
export const DEFAULT_WEB_LANGUAGE = "en-gb";
export const LANGUAGES = {
  "en-gb": {
    id: "en-gb",
    name: "english",
    file_name: "en.js"
  }
};

export const USER_ROLES = {
  ADMIN: { id: 1, role: "admin" },
  OPERATIONS: { id: 2, role: "operations" },
  AGENCY: { id: 3, role: "agency" },
  AGENCY_ACCOUNTS: { id: 4, role: "agency accounts" },
};

export const ENABLED_STATUSES = [
  { name: "All", value: null },
  { name: "Enabled", value: 1 },
  { name: "Disabled", value: 0 },
];

// Routes: Defined here if same route used multiple places
export const CAMPAIGN_SETUP_ROUTE = "campaigns/setup";

// Application routes
export const applicationRoutes = [
  // Default routes
  {
    path: "/",
    exact: true,
    component: "dataSearch",
    currentMenu: { group: "dataSearch", name: "dataSearch" }
  },
  {
    path: "/data-search",
    exact: true,
    component: "dataSearch",
    currentMenu: { group: "dataSearch", name: "dataSearch" }
  },
  {
    path: "/add-data",
    exact: true,
    component: "addData",
    currentMenu: { group: "addData", name: "addData" }
  },
  {
    path: "/enrich",
    exact: true,
    component: "enrich",
    currentMenu: { group: "enrich", name: "enrich" }
  },
  {
    path: "/history",
    exact: true,
    component: "history",
    currentMenu: { group: "history", name: "history" }
  },
  {
    path: "/history/saved-search/:id",
    exact: true,
    component: "savedDataSearch",
    currentMenu: { group: "history", name: "history" }
  },
  {
    path: "/settings",
    exact: true,
    component: "settings",
    currentMenu: { group: "", name: "" }
  }, {
    path: "/terms-and-conditions",
    exact: true,
    component: "underConstruction",
    currentMenu: { group: "", name: "" }
  },
];

export const tempConstant = {
  "APIRequestDateFormat": "YYYY-MM-DD",
  "momentDefaultDateFormat": "MM/DD/YYYY",
  "momentDisplayDateFormat": "DD/MM/YYYY",
  "displayDateFormat": "dd/MM/yyyy",
  "displayDateTimeFormat": "DD/MM/YYYY HH:mm:ss",
  "campaignTrackerDisplayDateFormat": "DD MMM YY",
  "allowedUploadFiles": {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"],
    "text/csv": [".csv"]
  },
  "allowedUploadFilesLabel": ".xlsx, .xls, .csv",
  "allowedDataUploadFiles": {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "text/csv": [".csv"]
  },
  "allowedDataUploadFilesLabel": ".xlsx, .xls, .csv",
  "dateRangeOptions": {
    "No Date": [moment().toDate(), moment().subtract(1, "days").toDate()],
    "This Week": [moment().startOf("week"), moment().endOf("week")],
    "Last Week": [
      moment().subtract(1, "weeks").startOf("week"),
      moment().subtract(1, "weeks").endOf("week")
    ],
    "This Month": [
      moment().startOf("month").toDate(),
      moment().endOf("month").toDate(),
    ],
    "Last Month": [
      moment().subtract(1, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
    "Last 3 Month": [
      moment().subtract(3, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
    "Last 6 Month": [
      moment().subtract(6, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
    "Last 12 Month": [
      moment().subtract(12, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
  },
  "roleWiseRedirections": [
    {
      roleIds: [1, 2, 3, 4],
      roles: ["admin", "operations", "agency admin", "agency accounts"],
      redirectionPath: "/add-data"
    }
  ]
};

export const LeadStatusWithAttributes = {
  "labelClass": {
    2: "text-danger bg-danger-df", 1: "text-success bg-success-df", 0: "bg-warning bg-warning-df", 3: "bg-warning bg-warning-df",
  },
  "labelFontClass": {
    2: "lead-reject-text", 1: "", 0: "lead-pending-text", 3: "lead-pending-text",
  },
  "qaLabels": {
    2: "FAIL", 1: "PASS", 0: "PENDING", 3: "WARNING",
  },
  "approveLabels": {
    2: "REJECTED", 1: "APPROVED", 0: "PENDING", 3: "WARNING",
  }
}

export const LeadStatus = {
  "1": { status: 1, "text": "Approved", "order": 0 },
  "0": { status: 0, "text": "Pending", "order": 1 },
  "2": { status: 2, "text": "Rejected", "order": 2 },
}

export const HIGHCHARTS_THEME = {
  fontFamily: "Inter, sans-serif",
  fontSize: "12px",
  fontWeight: "400",
  color: "#606276",
};

export const HIGHCHARTS_CONFIG = {
  chart: {
    style: HIGHCHARTS_THEME,
  },
  title: {
    style: HIGHCHARTS_THEME,
  },
  subtitle: {
    style: HIGHCHARTS_THEME,
  },
  legend: {
    itemStyle: HIGHCHARTS_THEME,
  },
  xAxis: {
    labels: {
      style: HIGHCHARTS_THEME,
    },
  },
  yAxis: {
    labels: {
      style: HIGHCHARTS_THEME,
    },
  },
  tooltip: {
    style: HIGHCHARTS_THEME,
  },
  time: {
    useUTC: true,
  },
  plotOptions: {
    column: {
      dataLabels: {
        enabled: true,
        style: HIGHCHARTS_THEME,
      },
    },
  },
};
